// src/lib/footprint-editor/history.js
//
// Undo and redo over the whole operation set. Each entry is the feature list
// before and after one operation (place, move, rotate, resize, numeric entry,
// duplicate, delete, align, line). Features are never mutated in place, so a
// snapshot is the array itself and costs one reference per feature.
//
// A drag is ONE operation: the editor previews while the pointer moves and
// commits once on release, so one undo takes the whole drag back.

export const HISTORY_LIMIT = 200;

export default class History {
  constructor(limit = HISTORY_LIMIT) {
    this.limit = limit;
    this.past = [];
    this.future = [];
  }

  /** Record an operation. A new operation clears what redo would have replayed. */
  push(label, before, after) {
    if (before === after) return;
    this.past.push({ label, before, after });
    if (this.past.length > this.limit) this.past.shift();
    this.future = [];
  }

  get canUndo() { return this.past.length > 0; }
  get canRedo() { return this.future.length > 0; }

  /** @returns {{label: string, features: object[]}|null} the list to restore */
  undo() {
    const e = this.past.pop();
    if (!e) return null;
    this.future.push(e);
    return { label: e.label, features: e.before };
  }

  redo() {
    const e = this.future.pop();
    if (!e) return null;
    this.past.push(e);
    return { label: e.label, features: e.after };
  }

  clear() { this.past = []; this.future = []; }
}
